export const LOCALE_EVENT = Symbol('LOCAL_EVENT')

export const SEARCH_EVENT_KEY = Symbol('SEARCH_EVENT_KEY')

// 搜索内容重置
export const SEARCH_RESET_EVENT_KEY = Symbol('SEARCH_RESET_EVENT_KEY')

// 搜索字段值更新
export const SEARCH_FIELD_UPDATE_EVENT_KEY = Symbol('SEARCH_FIELD_UPDATE_EVENT_KEY')

export const EXPAND_ALL_CHANNEL_EVENT_KEY = Symbol('EXPAND_ALL_CHANNEL_EVENT_KEY')

export const CHANNEL_ADD_USER_EVENT_KEY = Symbol('CHANNEL_ADD_USER_EVENT_KEY')

export const CHANNEL_SET_ORG_LEADER = Symbol('CHANNEL_SET_ORG_LEADER')

// 当前登录接口已经请求成功
export const LOGIN_SUCCESS = Symbol('LOGIN_SUCCESS')

// 显示最新公告弹窗
export const SHOW_NEW_NOTICE = Symbol('SHOW_NEW_NOTICE')

// 刷新子账单列表
export const REFRESH_SUB_BILL_LIST = Symbol('REFRESH_SUB_BILL_LIST')

// 刷新仓库子列表
export const REFRESH_WAREHOUSE_SUB_LIST = Symbol('REFRESH_WAREHOUSE_SUB_LIST')
